import MUISlider, { SliderTypeMap } from '@material-ui/core/Slider';
import styled, { AnyStyledComponent } from 'styled-components';
import { color, TextColorProps } from 'styled-system';

type SliderProps = SliderTypeMap<TextColorProps>;

const Slider = styled(MUISlider as AnyStyledComponent)<SliderProps>`
  && {
    ${color}
  }
`;

Slider.defaultProps = {
  color: 'primary_pink_new',
};

export default Slider;
